jQuery(document).ready(function ($) {
  // search field
  //
  console.log("js: main is loaded");

  $(window).scroll(function () {
    if ($(window).scrollTop() >= 90) {
      $(".search-container.in-header").fadeOut(250);
    } else {
      $(".search-container.in-header").fadeIn(250);
    }
  });

  $(function () {
    $(".search-field").keyup(function () {
      if ($(this).val().length) {
        $(this).next(".placeholder").hide();
      } else {
        $(this).next(".placeholder").show();
      }
    });
    $(".placeholder").click(function () {
      $(this).next().focus();
    });
  });

  //navigation

  $(".pull-filter").click(function () {
    $("body").toggleClass("open-top");
    $("body").removeClass("open-main");
    return false;
  });

  if ($(window).width() < 991) {
    $(".menu-item-has-children > a").click(function () {
      $(this).next(".sub-menu").slideToggle("slow");
      return false;
    });
  }
  //and make undone when going wide again
  $(window).resize(function () {
    var w = $(window).width();
    if (w > 992) {
      $(".sub-menu").removeAttr("style");
    }
  });

  //launch sliders

  $(".hero-slider-left").flexslider({
    animationLoop: true,
    directionNav: false,
    controlNav: false,
    animation: "slide",
    direction: "vertical",
    slideshowSpeed: 5000,
  });

  $(".hero-slider-right").flexslider({
    animationLoop: true,
    directionNav: true,
    customDirectionNav: $(".hero-navigation a"),
    controlNav: false,
    animation: "slide",
    direction: "vertical",
    reverse: true,
    slideshowSpeed: 5000,
    sync: ".hero-slider-left",
  });

  $(".mobile-slider").flexslider({
    directionNav: false,
    customDirectionNav: $(".slider-navigation a"),
    controlNav: false,
    animation: "slide",
    slideshowSpeed: 5000,
  });

  $(".content-slider").flexslider({
    directionNav: true,
    //customDirectionNav: $('.slider-navigation a'),
    controlNav: false,
    animation: "slide",
    slideshowSpeed: 5000,
  });

  $(".gallery-slider").flexslider({
    directionNav: true,
    controlNav: false,
    slideshowSpeed: 4000,
  });

  $(".slider-5050-left").flexslider({
    animationLoop: true,
    directionNav: false,
    controlNav: false,
    animation: "slide",
    direction: "vertical",
    slideshowSpeed: 5000,
  });

  $(".slider-5050-right").flexslider({
    animationLoop: true,
    directionNav: true,
    customDirectionNav: $(".navigation-5050 a"),
    controlNav: false,
    animation: "slide",
    direction: "vertical",
    reverse: true,
    slideshowSpeed: 5000,
    sync: ".slider-5050-left",
  });

  //auto scroll

  $(".scroll").on("click", function () {
    id = $(this).attr("href");
    $("html, body").animate(
      {
        scrollTop: $(id).offset().top - 120,
      },
      900,
    );
    return false;
  });

  //favorite posts
  /*
function wpfp_do_js( dhis, doAjax ) {
    loadingImg = dhis.prev();
    loadingImg.show();
    beforeImg = dhis.prev().prev();
    beforeImg.hide();
    url = document.location.href.split('#')[0];
    params = dhis.attr('href').replace('?', '') + '&ajax=1';
    if ( doAjax ) {
        jQuery.get(url, params, function(data) {
                dhis.parent().html(data);
                if(typeof wpfp_after_ajax == 'function') {
                    wpfp_after_ajax( dhis ); // use this like a wp action.
                }
                loadingImg.hide();
            }
        );
    }
}

$('.wpfp-link').live('click', function() {
    dhis = $(this);
    wpfp_do_js( dhis, 1 );
      if (dhis.hasClass('remove-parent')) {
        dhis.closest('.col-xs-12').fadeOut();
      }
      return false;
});

*/

  //placeholders
  jQuery("#user_login").attr("placeholder", "Gebruiksnaam of e-mailadres");
  jQuery("#user_pass").attr("placeholder", "Wachtwoord");

  //comments

  $(".comment-wrap,.comment-submit").wrapAll('<div class="comment-reveal"></div>');
  $("#comment").focus(function () {
    $(".comment-reveal, .wysija-after-comment").slideDown();
    $(this).addClass("collapsed");
  });

  //order results

  $.urlParam = function (name) {
    var results = new RegExp("[\?&]" + name + "=([^&#]*)").exec(window.location.href);
    if (results == null) {
      return null;
    } else {
      return decodeURI(results[1]) || 0;
    }
  };

  var orderby = jQuery("#orderby");
  var str;
  orderby.change(function () {
    str = jQuery(this).val();
    window.location.href = "?o=" + str;
  });

  var ordersearch = jQuery("#ordersearch");
  var str;
  var url = $.urlParam("s");
  ordersearch.change(function () {
    str = jQuery(this).val();
    window.location.href = "?s=" + url + "&o=" + str;
  });

  //play video

  $(".load-video").click(function () {
    $(".video-container").fadeIn();
    $(".video-placeholder").hide();
    $(".load-video").fadeOut();
    return false;
  });

  $(".autop-youtube").click(function () {
    $(".video-container iframe").attr("src", $(".video-container iframe").attr("src") + "&autoplay=1");
  });
  $(".autop-video").click(function () {
    $(".video-container iframe").attr("src", $(".video-container iframe").attr("src") + "?autoPlay=true");
  });

  //filter

  var $filter_form = $(".filter_form");
  //$filter_form.find('.filter_options').hide();

  $filter_form.find(".filter_button").click(function (e) {
    $filter_form.find(".filter_col").toggleClass("open");

    //var $menu = $(this).next('.filter_options').slideToggle();
    //$('.filter_options', $filter_form).not($menu).slideUp();
    //$('.filter_button', $filter_form).not($button).removeClass('open');

    var $col = $(this).parent(".filter_col");
    $(".filter_col", $filter_form).not($col).removeClass("open");

    e.preventDefault();
  });

  $(".filter_col.active .reset_button").click(function () {
    $(this).next("ul").find("li").find("input[type=checkbox]").prop("checked", false);
    $("#filter").submit();
  });

  jQuery(function ($) {
    $("#filter").on("change", "input:checkbox", function () {
      $("#filter").submit();
    });
  });
});
